<div class="chat-scroll-area h-100 w-100 d-flex flex-column" copilotStickToBottom [resizeBehavior]="'instant'">
  <div data-stick-to-bottom-content class="chat-scroll-content d-flex flex-column gap-3 p-3 flex-fill">
    @if (!showCursor() && items().length === 0) {
    <lib-chat-idle-state />
    } @for (item of items(); track trackItem($index, item); let last = $last) {
      @switch (item.kind) {
        @case ('assistant') {
    <lib-chat-assistant-message [message]="item.message" [toolCalls]="item.toolCalls" [showCursor]="last && showCursor()" />
        }
        @case ('user') {
    <lib-chat-user-message [message]="item.message" />
        }
        @case ('reasoning') {
    <lib-reasoning-step [stepInfo]="item.stepInfo" [isStreaming]="last && showCursor()" />
        }
        @case ('todo_list') {
    <app-todo-list-card [todos]="item.todos" [toolCall]="item.toolCall" [title]="item.label ?? 'To-do list'" />
        }
@case ('blackboard') {
    <app-plan-progress-card />
      }
    }
    }
    <!-- Evidence progress (DEBUG-ONLY, standalone family — never inside the plan card):
         renders the ephemeral evidence_progress tool-call brackets from the container-scoped
         store right after the message items (the plan-progress trace point's surface), once
         per list. Triple-guarded here (store present, debug mode on, visible views); the card
         re-guards itself the same way. -->
    @if (showEvidence()) {
      <app-evidence-progress-card class="d-flex flex-column gap-2" />
    }
    @if (showAnalyzing()) {
    <lib-reasoning-step [stepInfo]="analyzingStepInfo" [isStreaming]="true" />
    }
  </div>
</div>
